module.exports = __webpack_public_path__ + "fonts/Inter-200-greek-ext13.2329210.woff2";